module.exports = __webpack_public_path__ + "img/ico_zoomout.6dfb401e.png";